import { queryCustomers } from './service'

export const search = {
  inputs: [
    {
      type: 'InputSelect',
      title: 'Type',
      span: 6,
      options: 'getters/search/invPageTypeAll',
      getter: 'state/search/orderType',
      setter: 'commit/search/setOrderType',
      defaultValue: 1
    },
    {
      type: 'InputDateRangePicker',
      title: 'Date',
      span: 6,
      getter: 'state/search/dateRange',
      setter: 'commit/search/setDateRange'
    },
    {
      type: 'InputDateRangePicker',
      title: 'Due Date',
      span: 6,
      getter: 'state/search/dueDateRange',
      setter: 'commit/search/setDueDateRange'
    },
    {
      type: 'InputSelect',
      title: 'TAG',
      span: 6,
      options: 'getters/search/invTagsWithAll',
      getter: 'state/search/tag',
      setter: 'commit/search/setTag',
      defaultValue: 0
    },
    {
      type: 'InputText',
      title: 'Number',
      span: 6,
      placeholder: 'Number Keyword',
      getter: 'state/search/no',
      setter: 'commit/search/setNo',
      width: 200
    },
    {
      type: 'InputText',
      title: 'To CSR',
      span: 6,
      placeholder: 'Customer Name Keyword',
      getter: 'state/search/csrWord',
      setter: 'commit/search/setCsrWord',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Reference',
      span: 6,
      placeholder: 'Reference Keyword',
      getter: 'state/search/reference',
      setter: 'commit/search/setReference',
      width: 200
    },
    {
      type: 'InputSelect',
      title: 'Drafter Type',
      span: 6,
      options: 'getters/search/drafterTypes',
      getter: 'state/search/drafterType',
      setter: 'commit/search/setDrafterType',
      defaultValue: 0
    },
    {
      type: 'InputText',
      title: 'Product Inside',
      span: 6,
      placeholder: 'Enter Products Keyword',
      getter: 'state/search/product',
      setter: 'commit/search/setProduct',
      width: 200
    },
    {
      type: 'InputSelect',
      title: 'Warehouse',
      span: 6,
      options: 'getters/warehosuesAll',
      getter: 'state/search/warehouse',
      setter: 'commit/search/setWarehouse',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'Sort Type',
      span: 6,
      options: 'getters/search/sortTypes',
      getter: 'state/search/sortType',
      setter: 'commit/search/setSortType',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'Deliver Status',
      span: 6,
      options: 'getters/search/deliStatusTypes',
      getter: 'state/search/deliveryStatus',
      setter: 'commit/search/setDeliveryStatus',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'Status',
      span: 6,
      options: 'getters/search/orderStatus',
      getter: 'state/search/status',
      setter: 'commit/search/setStatus',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'Print',
      span: 6,
      options: 'getters/search/prints',
      getter: 'state/search/print',
      setter: 'commit/search/setPrint',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'Xero Sent',
      span: 6,
      options: 'getters/search/xeroSends',
      getter: 'state/search/xeroSend',
      setter: 'commit/search/setXero',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'CSR Order Status',
      span: 6,
      options: 'getters/search/csrOrderStatus',
      getter: 'state/search/csrStatus',
      setter: 'commit/search/setCsrStatus',
      defaultValue: 0
    }
  ],
  lines: [
    {
      prop: 'no',
      label: 'Number',
      className: 'table-column-sheet-number-style',
      width: 90
    },
    {
      prop: 'ColumnIconShow',
      label: 'Type',
      getter: 'type',
      align: 'center',
      trans: 'getters/search/orderTypeIcon',
      width: 51
    },
    {
      prop: 'reference',
      label: 'Reference',
      width: 100
    },
    {
      prop: 'customer.name',
      label: 'To CSR'
    },
    {
      prop: 'qty',
      label: 'QTY.',
      width: 55,
      align: 'right',
      className: 'table-column-list-type-color-bold'
    },
    {
      prop: 'amount',
      label: 'Amount',
      width: 85,
      align: 'right',
      className: 'table-column-list-type-color-bold'
    },
    // {
    //   prop: 'ColumnShow',
    //   label: 'Warehouse',
    //   getter: 'warehouseId',
    //   trans: 'getters/getWarehouseName',
    //   width: 120
    // },
    {
      prop: 'ColumnShow',
      label: 'Date',
      getter: 'date',
      trans: 'getters/dateFormatAu',
      width: 95
    },
    {
      prop: 'ColumnShow',
      label: 'Dispatch',
      getter: 'deliveryDate',
      trans: 'getters/dateFormatAu',
      width: 95
    },
    {
      prop: 'ColumnShow',
      label: 'Drafter',
      getter: 'drafterType',
      trans: 'getters/getDrafterTypeColumnName',
      width: 70
    },
    {
      prop: 'lastApproverAndDate',
      label: 'Last Approver/Date',
      width: 170
    },
    {
      prop: 'ColumnDeliverStatus',
      label: 'D.Status/Driver',
      width: 115,
      rowKey: 'deliveryStatus'
    },
    {
      prop: 'ColumnShippingType',
      label: 'Area/Ship Type',
      width: 122,
      rowKey: 'shipType'
    },
    {
      prop: 'status',
      label: 'Status',
      width: 85
    },
    {
      prop: 'print',
      label: 'PRINT',
      width: 75
    },
    {
      prop: 'xeroSent',
      label: 'Xero',
      width: 70
    },
    {
      prop: 'ColumnViewBtn',
      label: 'Action',
      width: 80,
      align: 'center'
    }
  ]
}

export const edit = {
  inputs: [
    {
      type: 'InputTagWithOrderType',
      title: 'TAG',
      span: 8,
      placeholder: 'Select',
      options: 'getters/invoiceTags',
      getter: 'state/edit/tagId',
      setter: 'commit/edit/setTag',
      defaultValue: 1,
      width: 200
    },
    {
      type: 'InputShow',
      title: 'CSR Remark',
      span: 16,
      getter: 'state/edit/csr/attention',
      labelClass: 'detail-text-attention'
    },
    {
      type: 'divider'
    },
    {
      type: 'InputCSRWithBalance',
      title: 'To CSR',
      span: 12,
      placeholder: 'Enter CSR Name',
      query: queryCustomers,
      getter: 'getters/edit/csrName',
      setter: 'actions/edit/setCsrWithInfo',
      needBus: true,
      watch: 'state/edit/csr',
      width: 200
    },
    {
      type: 'InputDatePicker',
      title: 'Date',
      span: 6,
      getter: 'state/edit/date',
      setter: 'commit/edit/setDate',
      width: 200
    },
    {
      type: 'InputDatePicker',
      title: 'Dispatch Date',
      span: 6,
      getter: 'state/edit/deliveryDate',
      setter: 'commit/edit/setDeliveryDate',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Address',
      span: 12,
      placeholder: 'Enter an address of this sheet',
      getter: 'state/edit/address',
      setter: 'commit/edit/setAddress',
      autocomplete: 'new-password', // 变相避免浏览器自动填充
      width: 615
    },
    {
      type: 'InputText',
      title: 'Phone',
      span: 6,
      placeholder: 'Enter a phone of this sheet',
      getter: 'state/edit/phone',
      setter: 'commit/edit/setPhone',
      autocomplete: 'new-password' // 变相避免浏览器自动填充
    },
    {
      type: 'InputDatePicker',
      title: 'Due Date',
      span: 6,
      getter: 'state/edit/dueDate',
      setter: 'commit/edit/setDueDate',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Reference',
      span: 12,
      placeholder: 'Enter reference only',
      getter: 'state/edit/reference',
      setter: 'commit/edit/setReference',
      width: 615
    },
    {
      type: 'InputSelect',
      title: 'Service Staff',
      span: 6,
      options: 'getters/sales',
      getter: 'state/edit/csrServiceId',
      setter: 'commit/edit/setCsrServicer',
      defaultValue: ''
    },
    {
      type: 'InputSelect',
      title: 'Business Staff',
      span: 6,
      options: 'getters/bd',
      getter: 'state/edit/csrBDId',
      setter: 'commit/edit/setBD',
      autocomplete: 'new-password', // 变相避免浏览器自动填充
      defaultValue: ''
    },
    {
      type: 'InputText',
      title: 'CSR Self Note',
      span: 12,
      placeholder: 'For customer online ordering self notes only',
      getter: 'state/edit/csrSelfNote',
      setter: 'commit/edit/setCsrSelfNote',
      width: 615
    },
    {
      type: 'InputText',
      title: 'Comments',
      span: 12,
      placeholder: 'Enter comments for this sheet',
      getter: 'state/edit/comments',
      setter: 'commit/edit/setComments',
      width: 615
    }
  ],
  lines: [
    {
      prop: 'ColumnProductCodeSelectPopper',
      label: 'Item Code',
      width: 190
    },
    {
      prop: 'ColumnProductNameInput',
      label: 'Item Name',
      width: 330
    },
    {
      prop: 'product.unit',
      label: 'Unit',
      width: 70
    },
    {
      prop: 'ColumnStockDropDown',
      label: 'Stock',
      width: 70
    },
    {
      prop: 'ColumnInputQty',
      label: 'Qty',
      width: 85
    },
    {
      prop: 'ColumnPriceDropDownWithInput',
      label: 'Unit Price',
      width: 145
    },
    {
      prop: 'ColumnLineAmount',
      label: 'Line Amount',
      width: 100
    },
    {
      prop: 'BillHistory',
      label: 'History',
      width: 80,
      align: 'center'
    },
    {
      prop: 'ColumnLineTaxType',
      label: 'Tax Type',
      width: 120
    },
    {
      prop: 'ColumnInputDesc',
      label: 'Line Description'
    }
  ]
}

export const draft = {
  inputs: [
    {
      type: 'InputShow',
      title: 'TAG',
      span: 6,
      getter: 'state/edit/tagId',
      trans: 'getters/getTagName',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputShow',
      title: 'Number',
      span: 6,
      getter: 'state/edit/no',
      labelClass: 'detail-text-strong'
    },
    {
      type: 'InputShow',
      title: 'CSR Remark',
      span: 12,
      getter: 'state/edit/csr/attention',
      labelClass: 'detail-text-strong'
    },
    {
      type: 'divider'
    },
    {
      type: 'InputShow',
      title: 'To CSR',
      span: 6,
      getter: 'getters/edit/csrName',
      labelClass: 'detail-text-strong-blue'
    },
    {
      type: 'InputShow',
      title: 'Price Type',
      span: 6,
      getter: 'state/edit/priceType',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputShow',
      title: 'Date',
      span: 6,
      getter: 'state/edit/date',
      trans: 'getters/dateFormatAu',
      labelClass: 'detail-text-strong'
    },
    {
      type: 'InputShow',
      title: 'Dispatch Date',
      span: 6,
      getter: 'state/edit/deliveryDate',
      trans: 'getters/dateFormatAu',
      labelClass: 'detail-text-strong'
    },
    {
      type: 'InputShow',
      title: 'Address',
      span: 12,
      // getter: 'state/edit/address',
      getter: 'getters/edit/addressAndPhone',
      labelClass: 'detail-text-grey'
    },
    // {
    //   type: 'InputShow',
    //   title: 'Phone',
    //   span: 6,
    //   getter: 'state/edit/phone',
    //   labelClass: 'detail-text-grey'
    // },
    {
      type: 'InputShow',
      title: 'Due Date',
      span: 6,
      getter: 'state/edit/dueDate',
      trans: 'getters/dateFormatAu',
      labelClass: 'detail-text-strong'
    },
    {
      type: 'InputShow',
      title: 'Service Staff',
      span: 6,
      getter: 'state/edit/csrServiceId',
      trans: 'getters/getStaffName',
      labelClass: 'detail-text-strong-blue'
    },
    {
      type: 'InputShow',
      title: 'Reference',
      span: 12,
      getter: 'state/edit/reference',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputShow',
      title: 'Payment Type',
      span: 6,
      getter: 'state/edit/paymentType',
      labelClass: 'detail-text-strong-green'
    },
    {
      type: 'InputShow',
      title: 'Business Staff',
      span: 6,
      getter: 'state/edit/csrBDId',
      trans: 'getters/getStaffName',
      labelClass: 'detail-text-strong-blue'
    },
    {
      type: 'InputShow',
      title: 'CSR Self Note',
      span: 12,
      getter: 'state/edit/csrSelfNote',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputShow',
      title: 'Area Type',
      span: 6,
      getter: 'state/edit/areaType',
      labelClass: 'detail-text-strong-green'
    },
    {
      type: 'InputSelect',
      title: 'Driver',
      span: 6,
      placeholder: 'Optional',
      options: 'getters/drivers',
      getter: 'state/edit/driverId',
      setter: 'commit/edit/setDriver',
      defaultValue: ''
    },
    {
      type: 'InputShow',
      title: 'Comments',
      span: 12,
      getter: 'state/edit/comments',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputSelect',
      title: 'Warehouse',
      span: 6,
      options: 'state/warehouses',
      getter: 'state/edit/warehouseId',
      setter: 'commit/edit/setWarehouse'
      // defaultValue: ''
    },
    {
      type: 'InputSelect',
      title: 'Shipping type',
      span: 6,
      options: 'state/shipTypes',
      getter: 'state/edit/shipType',
      setter: 'commit/edit/setShipType'
    }
  ],
  lines: [
    {
      prop: 'ColumnShow',
      label: 'Item Code',
      getter: 'product.code',
      width: 150
    },
    {
      prop: 'ColumnShow',
      label: 'Item Name',
      getter: 'product.name',
      width: 350
    },
    {
      prop: 'unit',
      label: 'Unit',
      width: 70
    },
    {
      prop: 'ColumnStockDropDown',
      label: 'Stock',
      width: 70
    },
    {
      prop: 'quantity',
      label: 'Qty',
      width: 65
    },
    {
      prop: 'price',
      label: 'Unit Price',
      width: 90
    },
    {
      prop: 'line_amount',
      label: 'Line Amount',
      width: 100
    },
    {
      prop: 'ColumnPriceDropDown',
      label: 'Prices',
      width: 80
    },
    {
      prop: 'BillHistory',
      label: 'History',
      width: 80,
      align: 'center'
    },
    {
      prop: 'ColumnLineTaxType',
      label: 'Tax Type',
      width: 140
    },
    {
      prop: 'desc',
      label: 'Line Description'
    }
  ]
}

const approve = { ...draft }

approve.inputs = draft.inputs.slice(0, draft.inputs.length - 4)

approve.inputs.push(
  ...[
    {
      type: 'InputShow',
      title: 'Driver',
      span: 6,
      getter: 'state/edit/driverId',
      trans: 'getters/getDriverName',
      labelClass: 'detail-text-strong-blue'
    },
    {
      type: 'InputShow',
      title: 'Comments',
      span: 12,
      getter: 'state/edit/comments',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputShow',
      title: 'Warehouse',
      span: 6,
      getter: 'state/edit/warehouseId',
      trans: 'getters/getWarehouseName',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputShow',
      title: 'Shipping Type',
      span: 6,
      getter: 'state/edit/shipType',
      trans: 'getters/getShipTypeName',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputShow',
      title: 'Driver Comment',
      span: 12,
      getter: 'state/edit/deliveryComment',
      labelClass: 'detail-text-strong-deliver'
    },
    {
      type: 'InputShow',
      title: 'Actual Pay Type',
      span: 6,
      getter: 'state/edit/actualPayType',
      trans: 'getters/getActualPayName',
      labelClass: 'detail-text-strong-green'
    },
    {
      type: 'InputShow',
      title: 'Delivery Status',
      span: 6,
      getter: 'state/edit/deliveryStatus',
      trans: 'getters/getDlvStatusName',
      labelClass: 'detail-text-strong-deliver'
    }
  ]
)

export default { search, edit, draft, approve }
